import React, { useMemo, useState, useEffect } from "react";
import PageHeader from "../../Components/shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import { Link, useLocation, useParams } from "react-router-dom";
import { fetchData, fetchFormData, getValueLabel } from "../../utils/options";
import topTost from "../../utils/topTost";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import SelectDropdown from "../shared/SelectDropdown";
import MultiSelectTags from "../shared/MultiSelectTags";
import Table from "../shared/table/Table";
const Assigned_Lead = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const ID = queryParams.get("ID") || "";
  const userId = localStorage.getItem("id");
  const selectedLeads = location.state?.selectedLeads || [];
  const insertedCount = location.state?.insertedCount || 0;

  const [branchData, setBranchData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [updateData, setUpdateData] = useState([]);
  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
  const [inputValues, setInputValues] = useState({});
  const [branchUserData, setBranchUserData] = useState([]);

  const [data, setData] = useState({
    branch_id: "",
    employee_id: "",
  });

  const totalLead = selectedLeads.length > 0
    ? selectedLeads.reduce((sum, item) => sum + item.numberOfLead, 0)
    : insertedCount;

  const fetchAllData = async () => {
    const formData = new FormData();
    formData.append("created_by", userId);
    // formData.append("moduleId", M_id);
    const result = await fetchFormData("branch/listdropdown", formData, "POST");

    if (result) {
      const user = result.branches;
      setBranchData(getValueLabel(user, "branch_name", "id") || []);
    }
  };

  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchEmployeesByBranch = async (branchIds) => {
    try {
      const formData = new FormData();
      formData.append("branch_ids", branchIds);
      formData.append("created_by", userId);

      const result = await fetchFormData(
        "get-employees-by-branch",
        formData,
        "POST"
      );

      if (result?.code === 200 && result?.data) {
        setBranchUserData(getValueLabel(result.data, "name", "id") || []);
      } else {
        console.error("No employees found for selected branches");
      }
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const handleBranchChange = async (value) => {
    if (value) {
      setData((prev) => ({
        ...prev,
        branch_id: value.value,
      }));
      await fetchEmployeesByBranch(value.value);
    }
  };

  const handleEmployeeChange = (selectedOptions) => {
    const values = selectedOptions?.map((opt) => opt.value) || [];
    setSelectedEmployeeIds(values);
  };

  const handleNumberInput = (id, value) => {
    setInputValues((prev) => ({ ...prev, [id]: value }));
  };

  useEffect(() => {
    const count = selectedEmployeeIds.length;
    if (count === 0) {
      setUpdateData([]);
      return;
    }

    const base = Math.floor(totalLead / count);
    const remainder = totalLead % count;

    const updated = branchUserData
      .filter((emp) => selectedEmployeeIds.includes(emp.value))
      .map((emp, index) => {
        const defaultLead = index < remainder ? base + 1 : base;

        return {
          id: emp.value,
          employee_name: emp.label,
          branch_name:
            branchData.find((b) => b.value === data.branch_id)?.label || "-",
          lead: String(defaultLead), // always assign calculated lead
        };
      });

    setUpdateData(updated);
  }, [selectedEmployeeIds, branchUserData, branchData, data.branch_id, totalLead]);




  const handleAllCheck = (event) => {
    if (event.target.checked) {
      const allIds = branchUserData.map((item) => item.value);
      setSelectedEmployeeIds(allIds);
    } else {
      setSelectedEmployeeIds([]);
    }
  };
  const calculateTotalAmount = (details) => {
    let totalAmount = 0;
    details.forEach((detail) => {
      let amount = parseFloat(detail.lead);
      if (!isNaN(amount)) {
        totalAmount += amount;
      }
    });
    return totalAmount;
  };
  const handleLeadChange = (value, index) => {
    const newUpdateData = [...updateData];
    newUpdateData[index].lead = value; // keep it as string for typing
    setUpdateData(newUpdateData);
  };

  const handleSubmit = async () => {
    const totalAssigned = calculateTotalAmount(updateData);

    const formData = new FormData();
    formData.append("TransitionID", ID);
    // formData.append("branchID", data.branch_id);
    formData.append("created_by", userId);

    updateData.forEach((emp, index) => {
      const leadCount = Number(emp.lead) || 0;
      if (leadCount > 0) {
        formData.append(`transfers[${index}][assigned_to]`, emp.id);
        formData.append(`transfers[${index}][no_of_leads]`, leadCount);
        formData.append(`transfers[${index}][branchID]`, data.branch_id);
      }
    });

    try {
      const response = await fetchFormData("transfer-leads", formData, "POST");

      if (response?.code === 200) {
        topTost({
          title: response.message || "Leads transferred successfully!",
        });
        setUpdateData([]);
        setSelectedEmployeeIds([]);
      } else {
        topTost({
          title: response.message || "Failed to transfer leads.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Submit error:", error);
    }
  };

  const columns = [
    {
      accessorKey: "branch_name",
      header: "Branch Name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "employee_name",
      header: "Employee Name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "number_input",
      header: "Number of leads",
      cell: ({ row }) => {
        const index = row.index;
        return (
          <input
            type="number"
            inputMode="numeric"
            className="form-control"
            value={updateData[index]?.lead || ""}
            onChange={(e) => handleLeadChange(e.target.value, index)}
          />
        );
      },

      defaultIsVisible: true,
    },
  ];
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader />
          <div className="main-content">
            <div className="row">
              <div className="col-12">
                <div className="row px-3 my-3">
                  <div className="col-md-2 py-3">
                    <label className="fw-semibold">
                      Branch:<span className="text-danger px-2">*</span>
                    </label>
                  </div>
                  <div className="col-lg-4">
                    <SelectDropdown
                      options={branchData}
                      icon="feather-home"
                      value={Number(data.branch_id)}
                      name="branch_id"
                      selectedOption={
                        branchData.find(
                          (opt) => opt.value === data.branch_id
                        ) || ""
                      }
                      defaultSelect="Select Branch"
                      onSelectOption={handleBranchChange}
                    />
                  </div>
                  <div className="col-md-2 py-3">
                    <label className="fw-semibold">
                      Employee:<span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-lg-4">
                    <MultiSelectTags
                      options={branchUserData}
                      defaultSelect={[]}
                      placeholder="Select Employee"
                      onChange={handleEmployeeChange}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>

            {selectedEmployeeIds.length > 0 && (
              <div className="row px-3 mt-65">
                <div className="col-12">
                  <Table data={updateData} columns={columns} />
                </div>
         

                <Link to={`/home?id=1`} className="col-12 d-flex justify-content-center mb-2">
                  <button className="btn btn-primary" onClick={handleSubmit}>
                    Assigned
                  </button>
                </Link>
              </div>
            )}
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default Assigned_Lead;
